import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editPrivacyPolicy, getPrivacyPolicy } from "../../redux/services/informationSlice";
import Information from "../../common/information";
import { toast } from "react-toastify";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const [editorContent, setEditorContent] = useState("");
  const [selectedType, setSelectedType] = useState("course");

  const privacyPolicyData = useSelector((state) => state?.information?.privacyPolicyData);

  const handleEditorChange = (newContent) => {
    setEditorContent(newContent);
  };
  const getPrivacyPolicyData = useCallback(async (type) => {
    try {
      await dispatch(getPrivacyPolicy(type));
    } catch (error) {}
  }, [dispatch]);
  useEffect(() => {
    getPrivacyPolicyData(selectedType);
  }, [getPrivacyPolicyData,selectedType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(editPrivacyPolicy({ privacyPolicy: editorContent, type: selectedType }));
      if (response) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        getPrivacyPolicyData(selectedType);
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (privacyPolicyData) {
      setEditorContent(privacyPolicyData?.privacyPolicy);
    }
  }, [privacyPolicyData]);
  // const handleExportPDF = () => {
  //   generatePDF(editorContent, "PrivacyPolicy.pdf");
  // };
  return (
    <>
      <Information
        title="Privacy Policy"
        handleSubmit={handleSubmit}
        editorContent={editorContent}
        handleEditorChange={handleEditorChange}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        // handleExportPDF={handleExportPDF}
      />
    </>
  );
};

export default PrivacyPolicy;
